import 'react-activity/dist/react-activity.css';
import { COLORS } from '@cocolocala/ui-components';
import { css } from 'linaria';
import { styled } from 'linaria/react';
import React, { FC, ReactNode } from 'react';
import { Spinner } from 'react-activity';
import Spacer from '~/shared/components/shared/Spacer';
type Appearance = {
  background?: string;
  spinnerColor?: string;
  textColor?: string;
};
type Props = {
  isBusy: boolean;
  messageTitle?: string;
  messageBody?: string;
  appearance?: Appearance;
  children?: ReactNode;
};
const BusyOverlay: FC<Props> = ({
  isBusy,
  messageTitle,
  messageBody,
  appearance,
  children
}) => {
  const background = appearance?.background ?? 'rgba(0, 0, 0, 0.7)';
  const spinnerColor = appearance?.spinnerColor ?? COLORS.BACKGROUND.SURFACE;
  const textColor = appearance?.textColor ?? COLORS.INVERT_TEXT.PRIMARY;
  return <>
      {isBusy && <div className={OverlayCSS} style={{
      background: background
    }} onClick={e => e.stopPropagation()}>
          <BusyContainer>
            <Spinner size="25px" color={spinnerColor} speed={0.85} />
            <MessageContainer>
              {messageTitle ? <h2 className={MessageTitleCSS} style={{
            color: textColor
          }}>
                  {messageTitle}
                </h2> : <></>}
              {messageTitle && messageBody ? <Spacer vertical={'16px'} /> : <></>}
              {messageBody ? <p className={MessageBodyCSS} style={{
            color: textColor
          }}>
                  {messageBody}
                </p> : <></>}
            </MessageContainer>
          </BusyContainer>
        </div>}
      {children}
    </>;
};
export default BusyOverlay;
const OverlayCSS = "o1hyqdjg";
const BusyContainer = /*#__PURE__*/styled("div")({
  name: "BusyContainer",
  class: "b1noseiu"
});
const MessageContainer = /*#__PURE__*/styled("div")({
  name: "MessageContainer",
  class: "maodr08"
});
const MessageTitleCSS = "m1azvcjf";
const MessageBodyCSS = "m1blayfx";

require("./index.linaria.module.css!=!../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./index.tsx");